import { render, staticRenderFns } from "./MergeListPopup.vue?vue&type=template&id=dcda3586&"
import script from "./MergeListPopup.vue?vue&type=script&lang=js&"
export * from "./MergeListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports